import { Box, Paragraph } from '@zillow/constellation-10';

type ErrorContainerProps = {
  hasAuthError: boolean;
};

const AUTH_ERROR_MESSAGE =
  'This account does not have access to this conversation. If you have another account, check to make sure you are logged into the right one.';
const GENERIC_ERROR_MESSAGE = 'There was an error, please try again.';

export default function ErrorContainer({ hasAuthError }: ErrorContainerProps) {
  const messageContent = hasAuthError ? AUTH_ERROR_MESSAGE : GENERIC_ERROR_MESSAGE;

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Paragraph css={{ color: hasAuthError ? 'text.dark' : 'red.400' }}>{messageContent}</Paragraph>
    </Box>
  );
}
